import { REJECT_SESSION_TRANSFER, REJECT_SESSION_TRANSFER_SUCCESS, REJECT_SESSION_TRANSFER_ERROR, REJECT_SESSION_TRANSFER_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RejectSessionTransfer = (state = initialState, action) => {
  switch (action.type) {
    case REJECT_SESSION_TRANSFER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case REJECT_SESSION_TRANSFER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case REJECT_SESSION_TRANSFER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case REJECT_SESSION_TRANSFER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RejectSessionTransfer;
